import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '订阅者',
    type: 'EVENT_SUBSCRIBER',
}
